import { useState } from 'react';
import { sqWorkbooksApi } from '@/sdk/api/WorkbooksApi';
import { FakeLink } from '@/core/FakeLink';
import { goToWorksheet } from '@/impactReports/impactReport.utilities';
import { useAsyncEffect } from 'rooks';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';
import { sqWorkbenchStore } from '@/core/core.stores';

interface SelectedWorksheetDisplayAndLinkProps {
  worksheetId: string;
  workbookId: string;
}
export const SelectedWorksheetDisplayAndLink: React.FunctionComponent<SelectedWorksheetDisplayAndLinkProps> = ({
  workbookId,
  worksheetId,
}) => {
  const [selectedWorksheetDisplayName, setSelectedWorksheetDisplayName] = useState('');
  const preferNewTab = useFluxPath(sqWorkbenchStore, () => sqWorkbenchStore.preferNewTab);

  useAsyncEffect(async () => {
    if (!workbookId || !worksheetId) return;
    const workbookResponse = await sqWorkbooksApi.getWorkbook({ id: workbookId });
    const worksheetResponse = await sqWorkbooksApi.getWorksheet({ workbookId, worksheetId });
    setSelectedWorksheetDisplayName(`${workbookResponse.data?.name} - ${worksheetResponse.data?.name}`);
  }, [worksheetId, workbookId]);

  return (
    <FakeLink onClick={() => goToWorksheet(worksheetId, preferNewTab)} extraClassNames="truncateWSLink">
      {selectedWorksheetDisplayName}
    </FakeLink>
  );
};
